var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GChart',{attrs:{"type":"AreaChart","data":_vm.dataTable,"options":_vm.options}})}
var staticRenderFns = []

export { render, staticRenderFns }